import React, { useState, useEffect, useRef } from "react";
import { Navbar } from "@/components/Navbar";
import { AnnouncementBanner } from "@/components/AnnouncementBanner";
import { Footer } from "@/components/Footer";
import { StickyMobileCTA } from "@/components/StickyMobileCTA";
import { GuaranteeModal } from "@/components/GuaranteeModal";
import { Hero } from "@/components/landing/Hero";
import { GuaranteeStrip, GuaranteeSection, WhyGuarantee, SocialProof } from "@/components/landing/GuaranteeSections";
import { ProblemSection, TransformationSection } from "@/components/landing/ProblemTransform";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { ProductSections } from "@/components/landing/Product";
import { PricingSection } from "@/components/landing/Pricing";
import { ValueAnchor, WhoItsFor, FAQSection, FinalCTA } from "@/components/landing/ExtraSections";
import { track, EVENTS } from "@/lib/analytics";

export default function Home() {
  const [guaranteeOpen, setGuaranteeOpen] = useState(false);
  const featuresRef = useRef(null);

  useEffect(() => {
    track(EVENTS.LANDING_VIEW);
    document.title = "sarkarijobai — AI Exam Success Platform for JEE, NEET & Govt Exams";
    // Fire the landing-view event once on mount; track/EVENTS are stable module imports.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const scrollToHow = () => document.getElementById("how")?.scrollIntoView({ behavior: "smooth" });

  return (
    <div className="min-h-screen bg-background">
      <AnnouncementBanner />
      <Navbar topOffset />
      <main>
        <Hero onSeeGuarantee={() => setGuaranteeOpen(true)} onSeeHow={scrollToHow} />
        <GuaranteeStrip />
        <ProblemSection />
        <TransformationSection />
        <HowItWorks />
        <ProductSections />
        <GuaranteeSection onReadTerms={() => setGuaranteeOpen(true)} />
        <WhyGuarantee />
        <SocialProof />
        <PricingSection />
        <ValueAnchor />
        <WhoItsFor />
        <FAQSection />
        <FinalCTA />
      </main>
      <Footer />
      <StickyMobileCTA />
      <GuaranteeModal open={guaranteeOpen} onOpenChange={setGuaranteeOpen} />
    </div>
  );
}
